import type { WorkspaceDetailMemberType } from '@/api/gen/_model/workspaceDetailMemberType';

import { getInquiryLinkByCountryCode } from '../consts/inquiryLinks';

export const PLAN_MANAGEMENT_PATH = '/profile/plan';

export type PlanExpirationAlertCta =
  | { kind: 'inquiry'; href: string }
  | { kind: 'manage'; href: typeof PLAN_MANAGEMENT_PATH };

/**
 * 셀프 연장이 가능할 때만 플랜 관리로 보낸다. 단체·이용권·판정불가는 전부 문의로 폴백한다.
 * 연장 가능 여부는 `resolveUpsellingPlanState` 가 판정한다 — 여기서 재계산하지 않는다.
 */
export const resolveExpirationAlertCta = ({
  workspaceMemberType,
  canSelfServeExtend,
  countryCode,
}: {
  workspaceMemberType: WorkspaceDetailMemberType;
  canSelfServeExtend: boolean;
  countryCode?: string | null;
}): PlanExpirationAlertCta | null => {
  if (workspaceMemberType !== 'OWNER') {
    return null;
  }

  if (canSelfServeExtend) {
    return { kind: 'manage', href: PLAN_MANAGEMENT_PATH };
  }

  return {
    kind: 'inquiry',
    href: getInquiryLinkByCountryCode(countryCode, 'planExtension'),
  };
};
